<section class="wrap">
  <app-banner></app-banner>
  <app-feature></app-feature>
  <app-buy-with></app-buy-with>
  <app-portfolio></app-portfolio>
  <app-market-insights></app-market-insights>
  <app-token></app-token>
  <app-best-token-airdrop></app-best-token-airdrop>
  <app-best-dex></app-best-dex>
  <app-roadmap></app-roadmap>
  <app-faq></app-faq>
</section>